import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "rank-history",
  components: {
    AppHeader
  },
  created() {
    this.getUser();
    this.getRankHistory();
  },
  data() {
    return {
      getRankHistoryEnd: false,
      rankHistories: [],
      user: ""
    };
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    async getRankHistory() {
      this.getRankHistoryEnd = false;
      let data = {
        user_id: this.$route.params.user_id
      };
      let res = await this.$store
        .dispatch("GET_RANK_HISTORY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.rankHistories = res.rank_histories;
      this.getRankHistoryEnd = true;
    },
    authorityCheck(menu) {
      if (menu == "rank" && localStorage.user_authority == 4) {
        // 総務部でログイン
        return false;
      } else if (localStorage.user_authority == 2) {
        if (menu == "add" || menu == "edit" || menu == "delete") {
          return false;
        }
      }
      return true;
    },
    deleteModal(rankHistoryId) {
      this.deleteRankHistoryId = rankHistoryId;
      this.$bvModal.show("modal-delete");
    },
    async deleteRankHistory() {
      let res = await this.$store
        .dispatch("DELETE_RANK_HISTORY", {
          id: this.deleteRankHistoryId,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        this.getRankHistory();
      }
      this.$bvModal.hide("modal-delete");
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    },
    goAccidentHistory() {
      this.$router.push({
        path: `/accident_history/${this.$route.params.user_id}`
      });
    },
    goRankHistoryNew() {
      this.$router.push({
        path: `/rank_history/${this.$route.params.user_id}/new`
      });
    },
    goRankHistoryEdit(rankHistoryId) {
      this.$router.push({ path: `/rank_history/${rankHistoryId}/edit` });
    },
    content(word) {
      return word
        ? word
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;")
            .replace(/\r?\n/g, "<br>")
        : "";
    },
    dateFormat(date) {
      return dayjs(date).format("YYYY年MM月DD日");
    }
  }
};
